import { FC } from 'react';

interface ItalicsIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const ItalicsIcon: FC<ItalicsIconProps> = ({ color = 'currentColor', size = '16', className, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M7 2.79688H12C12.1865 2.79687 12.3652 2.87107 12.4971 3.00293C12.6289 3.13479 12.7031 3.31352 12.7031 3.5C12.7031 3.68648 12.6289 3.86521 12.4971 3.99707C12.3652 4.12893 12.1865 4.20312 12 4.20312H10.0068L7.47559 11.7969H9C9.18648 11.7969 9.36521 11.8711 9.49707 12.0029C9.62893 12.1348 9.70312 12.3135 9.70312 12.5C9.70312 12.6865 9.62893 12.8652 9.49707 12.9971C9.36521 13.1289 9.18648 13.2031 9 13.2031H4C3.81352 13.2031 3.63479 13.1289 3.50293 12.9971C3.37107 12.8652 3.29688 12.6865 3.29688 12.5C3.29688 12.3135 3.37107 12.1348 3.50293 12.0029C3.63479 11.8711 3.81352 11.7969 4 11.7969H5.99316L8.52441 4.20312H7C6.81352 4.20312 6.63479 4.12893 6.50293 3.99707C6.37107 3.86521 6.29688 3.68648 6.29688 3.5C6.29688 3.31352 6.37107 3.13479 6.50293 3.00293C6.63479 2.87107 6.81352 2.79688 7 2.79688Z"
      fill={color}
      stroke={color}
      strokeWidth="0.09375"
    />
  </svg>
);
